"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcHeaderBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_header_constants_1 = require("./bc-header-constants");
var bc_header_constants_2 = require("./bc-header-constants");
var bc_header_constants_3 = require("./bc-header-constants");
var bc_header_constants_4 = require("./bc-header-constants");
var bc_header_constants_5 = require("./bc-header-constants");
var bc_header_constants_6 = require("./bc-header-constants");
var bc_header_constants_7 = require("./bc-header-constants");
var bc_header_constants_8 = require("./bc-header-constants");
var helpers_1 = require("../../../common/helpers");
var BcHeaderBehavior = (function (_super) {
    __extends(BcHeaderBehavior, _super);
    function BcHeaderBehavior() {
        var _this = _super.call(this) || this;
        _this.dropdowns = [];
        _this.dropdownsContents = [];
        _this.dropdownActive = null;
        _this.menuButton = null;
        _this.communicationWithMenu = true;
        return _this;
    }
    BcHeaderBehavior.setUpAll = function () {
        var headerElements = Array.from(document.querySelectorAll("header[class^='".concat(bc_header_constants_1.BC_HEADER_CLASS, "']")));
        var elements = [];
        for (var _i = 0, headerElements_1 = headerElements; _i < headerElements_1.length; _i++) {
            var headerElement = headerElements_1[_i];
            var bcHeaderBehavior = new BcHeaderBehavior();
            bcHeaderBehavior.setElement(headerElement);
            bcHeaderBehavior.setUp();
            elements.push(bcHeaderBehavior);
        }
        return elements;
    };
    BcHeaderBehavior.prototype._setUp = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_MEMU_ITEMS, function () {
            _this.removeLogoutBtn();
        });
        this.addEventForOption();
        this.getMenuButton();
        this.accessibility();
        if (this.communicationWithMenu) {
            this.addEvents();
        }
        else {
            this.menuButton['style'].display = 'none';
        }
    };
    BcHeaderBehavior.prototype.setFocus = function () {
        var brandContainer = this.mySelf.querySelector(".".concat(bc_header_constants_4.BC_HEADER_BRAND));
        var headerNav = this.mySelf.querySelector(".".concat(bc_header_constants_2.BC_HEADER_NAV));
        var logoMobile = this.mySelf.querySelector(".".concat(bc_header_constants_1.BC_HEADER_NAV_ICON_MOBILE));
        if (brandContainer) {
            var menuIcon = this.menuButton;
            var channel = this.mySelf.querySelector(".".concat(bc_header_constants_1.BC_HEADER_CHANNEL));
            var brandLogo = this.mySelf.querySelector(".".concat(bc_header_constants_1.BC_HEADER_BRAND_LOGO));
            var items = headerNav.querySelectorAll(".".concat(bc_header_constants_2.BC_HEADER_NAV_ITEM));
            var elements = [menuIcon, brandLogo, channel, logoMobile];
            var navArray = Array.from(items);
            elements.forEach(function (i) {
                (0, helpers_1.addFocusable)(i, { tabindex: String(0) });
            });
            navArray.forEach(function (element) {
                (0, helpers_1.addFocusable)(element, { tabindex: String(-1) });
            });
            var floatMenu = this.mySelf.querySelector(".".concat(bc_header_constants_1.BC_HEADER_FLOAT_MENU));
            if (floatMenu) {
                floatMenu.classList.add("".concat(bc_header_constants_1.BC_HEADER_FLOAT_MENU_));
            }
        }
    };
    BcHeaderBehavior.prototype.getMenuButton = function () {
        var brandContainer = this.mySelf.querySelector(".".concat(bc_header_constants_4.BC_HEADER_BRAND));
        if (brandContainer !== null) {
            this.menuButton = brandContainer.querySelector(".".concat(bc_header_constants_5.BC_HEADER_BRAND_TOGGLE));
        }
    };
    BcHeaderBehavior.prototype.accessibility = function () {
        var _this = this;
        this.setFocus();
        var dropdown = this.mySelf.querySelectorAll(".".concat(bc_header_constants_3.BC_HEADER_DROPDOWN_CUSTOM));
        if (dropdown) {
            var toggle_1 = this.mySelf.querySelector(".".concat(bc_header_constants_2.BC_HEADER_TOGGLE));
            dropdown.forEach(function (element) {
                _this.setkeyBoard(element, toggle_1);
            });
            this.setFocus();
        }
    };
    BcHeaderBehavior.prototype.setkeyBoard = function (element, toggle) {
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                toggle.click();
            }
        });
    };
    BcHeaderBehavior.prototype.toggleSidebarMenu = function () {
        var toggleEvent = new CustomEvent(common_constants_1.BcCommonConstants.EVENT_HEADER_TOGGLE_MENU);
        window.dispatchEvent(toggleEvent);
    };
    BcHeaderBehavior.prototype.addMenuButtonEvent = function () {
        var _this = this;
        this.menuButton !== null && this.menuButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.toggleSidebarMenu();
        });
    };
    BcHeaderBehavior.prototype.removeLogoutBtn = function () {
        var logoutBtn = this.mySelf.querySelector(".".concat(bc_header_constants_7.BC_HEADER_LOGOUT_BUTTON_CLASS));
        if (logoutBtn) {
            logoutBtn.remove();
            this.mySelf.classList.add(bc_header_constants_8.BC_HEADER_NOT_LOGOUT_CLASS);
        }
    };
    BcHeaderBehavior.prototype.menuItemOpened = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_MENU_ITEM_OPENED, function (event) {
            if (event.detail.itemStatus !== null) {
                _this.mySelf.style.zIndex = '1';
            }
            else {
                _this.mySelf.style.zIndex = '999';
            }
        });
    };
    BcHeaderBehavior.prototype.addEvents = function () {
        this.iAmHere();
        this.addMenuButtonEvent();
        this.menuItemOpened();
    };
    BcHeaderBehavior.prototype.iAmHere = function () {
        var exist = new CustomEvent(common_constants_1.BcCommonConstants.EVENT_HEADER_EXIST);
        window.dispatchEvent(exist);
    };
    BcHeaderBehavior.prototype.addEventForOption = function (fn) {
        for (var _i = 0, _a = this.dropdownsContents; _i < _a.length; _i++) {
            var dropdownContent = _a[_i];
            var optionsUl = dropdownContent.children[0];
            for (var _b = 0, _c = optionsUl.children; _b < _c.length; _b++) {
                var optionLi = _c[_b];
                this.optionListener(optionLi, optionsUl);
            }
        }
    };
    BcHeaderBehavior.prototype.optionListener = function (optionLi, optionsUl) {
        var _this = this;
        if (!optionLi.getAttribute("listener")) {
            optionLi.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.addEventClick(optionsUl, optionLi);
            }, true);
        }
        optionLi.setAttribute('listener', common_constants_1.BcCommonConstants.EVENT_CLICK);
    };
    BcHeaderBehavior.prototype.addEventClick = function (optionsUl, optionLi) {
        var parentDropdown = optionsUl.closest(".".concat(bc_header_constants_3.BC_HEADER_DROPDOWN_CUSTOM));
        this.updateHeaderItemText(parentDropdown, optionLi);
    };
    BcHeaderBehavior.prototype.updateHeaderItemText = function (parent, option) {
        var text = parent.querySelector(common_constants_1.BcCommonConstants.P_TAG);
        var subText = parent.querySelector(common_constants_1.BcCommonConstants.SMALL);
        text.textContent = option.querySelector(common_constants_1.BcCommonConstants.P_TAG).textContent;
        if (subText) {
            subText.textContent = option.querySelector(common_constants_1.BcCommonConstants.SMALL).textContent;
        }
        var itemChanged = new CustomEvent(bc_header_constants_6.BC_HADER_CUSTOM_EVENT, {
            detail: subText != null ? { text: text.textContent, subText: subText.textContent } : { text: text.textContent },
        });
        window.dispatchEvent(itemChanged);
    };
    return BcHeaderBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcHeaderBehavior = BcHeaderBehavior;
